module.exports = __webpack_public_path__ + "img/av045.708112e6.png";